<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Auth from '@/api/Auth.js'
import Utils from '@/lib/util.js'
const router = useRouter()

// components 
let name = ref('')
let email = ref('');
let password = ref('');
let status = ref('');
let isSubmitting = ref(false);
let tos = ref(false)
let success = ref(false)
let failed = ref(false)
let message = ref("")

async function signUp() {
  isSubmitting.value = true
  // const { data } = await axios.get(context.env.apiUrl + "/api/services"); 
  // should send a verification email ---- 2FA??
  // let {data} = await Auth.register(this.email, this.password)
  let data  = await Auth.register(email.value, password.value, name.value)

  isSubmitting.value = false
  
  if(data.status) {
      email.value = ''
      password.value = ''
      success.value = true;            
  } else {
      failed.value = true
      //message.value = data.message
  }
}

const name_valid = computed(() => {
  return name.value != '' && name.value.length >= 3
})

const name_help = computed(() => {
  return name.value != '' && !name_valid.value
})

const password_valid = computed(() => {
  return password.value != '' && password.value.length >= 8
})

const password_help = computed(() => {
  return password.value != '' && !password_valid.value
})

const email_valid = computed(() => {
  return email.value != '' && Utils.is_email(email.value)
})

const email_help = computed(() => {
  return email.value != '' && !email_valid.value
})

</script>

<template>
  <div class="login-container">
      <!--<h3 class="subheader mb-4">Make sense of the internet</h3>-->
      <div class="alert alert-danger" v-if="failed" role="alert">
        Failed to create account. Please ensure you have entered the below information correct, and don't have an existing account
      </div>
      
      <div class="box bordered p-5">
        <div v-if="!success">
          <h3 class="mb-4 jura text-center">Create an account</h3>
          <div class="text-center mb-4">Already have an account? &nbsp;<router-link to="/login" class="link" style="color: white !important;">Login</router-link> </div>
          <p v-if="!success" class="ms-1 danger mb-4">{{message}}</p>
          <form action="#" @submit.prevent="signUp()" class="form-floating mb-4">
              <div class="mb-3">
                <div class="form-floating">
                    <input type="text" v-model="name" class="form-control dark" id="floatingInput" placeholder="name@example.com" :class="{invalid: name_help}">
                    <label for="floatingInput">Username</label>
                </div>
                <div v-if="name_help" class="small ps-2 pe-2 mt-1">
                  Should be atleast 3 alphanumeric characters long
                </div>
              </div>
              <div class="mb-3">
                <div class="form-floating">
                    <input type="email" v-model="email" class="form-control dark" id="floatingInput" placeholder="name@example.com" :class="{invalid: email_help}">
                    <label for="floatingInput">Email address</label>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-floating">
                    <input type="password" v-model="password" class="form-control dark" id="floatingPassword" placeholder="Password" :class="{invalid: password_help}">
                    <label for="floatingPassword">Password</label>
                </div>
                <div v-if="password_help" class="small ps-2 pe-2 mt-1">
                  Should be atleast 8 alphanumeric characters long
                </div>
              </div>
              <div class="mb-3 form-check ms-1">
                  <input type="checkbox" v-model="tos" class="form-check-input dark" id="exampleCheck1">
                  <label class="form-check-label"  for="exampleCheck1">I have read, understand, and accept the <router-link to="/resources/termsofservice">Terms of Service</router-link></label>
              </div>
              <button  v-if="!isSubmitting" :disabled="!email_valid || !name_valid || !password_valid || !tos" type="submit" class="btn btn-primary submit-btn">Sign up</button>
              <button  v-else disabled type="submit" class="btn btn-primary submit-btn">Creating account...</button>
          </form>
        </div>
        <div v-else>
          <h3 class="mb-4 jura text-center">Account created</h3>
          <div class=" mb-3">We've sent you a verification email. Use the link in the email to verify your account and login</div>
          <p class="mb-4">If you encounter any issues, don’t hesitate to reach out to our <router-link to="/about">support team</router-link></p>
          <div class="text-center"><router-link to="/login" class="link" style="color: inherit;">Go to login</router-link> </div>
        </div>
      </div>

  </div>
</template>


<style scoped>
.login-container {
  width: 450px;
}

.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.invalid {
  outline: 1px solid #ef8892; 
}

.danger {
    color: #ffb0b0;
    font-size: 1rem;
}

.submit-btn {
    height: 64px;
    background-color: #2D3642;
    font-size: 1rem;
    outline:none;
    width: 100%;
    box-shadow: none;
    border:none;
    border-radius: 10px;
}

#submit-btn:hover {
    background-color: #36404F;
}

.link:hover {
  text-decoration: underline;
}
</style>
